import React from 'react';

const NoDataComponent = ({dataName = ""}) => {
    return (
        <>
            <div className={"row pt-2"}>
                <div className={"col-12 text-center text-uppercase"}>
                    <h4 className={"no-data-message"}>Trenutno nema {dataName}</h4>
                </div>
            </div>
        </>
    );
};

export default NoDataComponent;
